import { Button, Select, Stack, Textarea } from "@chakra-ui/react";
import { FunctionComponent, useState } from "react";

// Hooks
import usePermission from "../../../hooks/usePermission";

// Protos
import { NoteTypeName } from "../../../utils/api/protos/messages/claims.message_pb";

interface NoteInputProps {
	noteType: NoteTypeName;
	setNoteType: (value: NoteTypeName) => void;
	newNote: string;
	setNewNote: (value: string) => void;
	handleAddNote: () => Promise<void>;
}

const NoteInput: FunctionComponent<NoteInputProps> = ({
	noteType,
	setNoteType,
	newNote,
	setNewNote,
	handleAddNote
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { hasLimitedUpdateAccess } = usePermission();

	return (
		<Stack marginBottom="24px" textAlign="left" gap="10px">
			<Select
				value={noteType}
				size="sm"
				width="170px"
				border="1px solid"
				borderColor="gray.400"
				borderRadius="4px"
				onChange={(e) => setNoteType(Number(e.target.value) as NoteTypeName)} // Cast string to NoteTypeName
			>
				<option value={NoteTypeName.NOTE_TYPE_GENERAL}>General</option>
				<option value={NoteTypeName.NOTE_TYPE_CASE_REVIEW}>Case Review</option>
				<option value={NoteTypeName.NOTE_TYPE_FOLLOW_UP}>Follow Up</option>
				<option value={NoteTypeName.NOTE_TYPE_OTHER}>Other</option>
			</Select>
			<Textarea
				value={newNote}
				onChange={(e) => setNewNote(e.target.value)}
				placeholder="Add a note..."
				width="100%"
				height="62px"
				minHeight="62px"
				padding="8px"
				border="1px solid"
				borderColor="gray.400"
				borderRadius="4px"
				_focus={{ zIndex: 0 }}
			/>
			<Button
				size="sm"
				width="100px"
				onClick={() => {
					setIsLoading(true);
					handleAddNote().finally(() => setIsLoading(false));
				}}
				isDisabled={newNote == null || newNote === "" || !hasLimitedUpdateAccess}
				isLoading={isLoading}
				colorScheme="orange">
				Post
			</Button>
		</Stack>
	);
};

export default NoteInput;
